const URL_PATTERN = /(^|[\s\n]|<[A-Za-z]*\/?>)((?:https?|ftp):\/\/[-A-Z0-9+\u0026\u2019@#/%?=()~_|!:,.;]*[-A-Z0-9+\u0026@#/%=~()_|])/gi;
export function linkify(s) {
    URL_PATTERN.lastIndex = 0;
    return s.replace(URL_PATTERN, '$1<a href=\'$2\' target="_blank">$2</a>');
}
